"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLevels = exports.getEvtcLevels = void 0;

var _sharedTypes = require("../logger/sharedTypes");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEBUG = _sharedTypes.Level[_sharedTypes.Level.DEBUG];
var evtcLevels = {
  'ACMS MODEL': DEBUG,
  'ACMS OPEN MODEL': DEBUG,
  'ACMS REQUEST SERVICE': DEBUG,
  'AEM MODEL': DEBUG,
  AEMSERVICE: DEBUG,
  'AFFILIATE CONTROLLER': DEBUG,
  'AFFILIATE REDIRECT MIDDLEWARE': DEBUG,
  AFFILIATE_PROSPECT_MIDDLEWARE: DEBUG,
  AJAX: DEBUG,
  'AKAMAI MODEL': DEBUG,
  'AKAMAI SERVICE': DEBUG,
  'APP BASE ROUTER': DEBUG,
  APP: DEBUG,
  'BUSINESS CARD COMPARISON MODEL': DEBUG,
  'BUSINESS CARD DETAILS CONTROLLER': DEBUG,
  'BUSINESS CATEGORY CONTROLLER': DEBUG,
  'BUSINESS CATEGORY MODEL': DEBUG,
  'BUSINESS HOME PAGE CONTROLLER': DEBUG,
  'CACHE BUST': DEBUG,
  'CARD CODES': DEBUG,
  'CARD DETAILS CONTROLLER': DEBUG,
  'CARD DETAILS MODEL': DEBUG,
  'CARD MODEL': DEBUG,
  'CARD SERVICE': DEBUG,
  'CARDS LANDING CONTROLLER': DEBUG,
  'CHECK OFFERS': DEBUG,
  'CM PZN EXT MODEL': DEBUG,
  'CM PZN EXTN CONTROLLER': DEBUG,
  'CM-PZN SERVICE': DEBUG,
  COMMERCIAL_FORCE_CONTROLLER: DEBUG,
  'COMMON UTILS': DEBUG,
  'COMPARE CARDS CONTROLLER': DEBUG,
  CONVERSION: DEBUG,
  'CORPORATE CATEGORY CONTROLLER': DEBUG,
  'CORPORATE CATEGORY MODEL': DEBUG,
  CORP_XSELL_CONTROLLER: DEBUG,
  CORP_XSELL_MODEL: DEBUG,
  CORP_XSELL_SERVICE: DEBUG,
  CORS: DEBUG,
  DECOMMISSIONED_CARD_MIDDLEWARE: DEBUG,
  'DTW CONTROLLER': DEBUG,
  'DTW MODEL': DEBUG,
  'ENCRYPT SERVICE': DEBUG,
  GLOBAL_DATA_MIDDLEWARE: DEBUG,
  HTTPUTILS: DEBUG,
  'ICM MODEL': DEBUG,
  'ICM SERVICE': DEBUG,
  'INAV SERVICE': DEBUG,
  INIT_MIDDLEWARE: DEBUG,
  JENKINS: DEBUG,
  'LEAD FORM CONTROLLER': DEBUG,
  'LEAD FORM SERVICE': DEBUG,
  'LOGIN CONTROLLER': DEBUG,
  'LOGIN MODEL': DEBUG,
  'LOGIN SERVICE': DEBUG,
  'OFFER GATING MODEL': DEBUG,
  'OFFER GATING': DEBUG,
  'OFFERS CONTROLLER': DEBUG,
  'OFFERS MODEL': DEBUG,
  'OFFSITE PZN': DEBUG,
  OFFSITE_PZN_MIDDLEWARE: DEBUG,
  'OPEN CATEGORY CONTROLLER': DEBUG,
  'OPEN CATEGORY MODEL': DEBUG,
  'OPEN GLOBAL DATA CONTROLLER': DEBUG,
  OPEN_INIT_MIDDLEWARE: DEBUG,
  OPEN_OFFER_GATING_CONTROLLER: DEBUG,
  OPEN_OFFER_GATING_MODEL: DEBUG,
  OPEN_PZN_CARD_VALIDATION: DEBUG,
  OPEN_PZN_CONTROLLER: DEBUG,
  OPEN_PZN_EXT_CONTROLLER: DEBUG,
  OPEN_PZN_EXT_SERVICE: DEBUG,
  OPEN_PZN_MIDDLEWARE: DEBUG,
  'PARTNER CARDS CONTROLLER': DEBUG,
  'PERFORMANCE CONTROLLER': DEBUG,
  'PRE POPULATE CONTROLLER': DEBUG,
  'PROSPECT CARD MODEL': DEBUG,
  'PZN EXTENSION CONTROLLER': DEBUG,
  'PZN EXTENSION TRACKING': DEBUG,
  'RATES MODEL': DEBUG,
  'RATES SERVICE': DEBUG,
  'RATINGS CONTROLLER': DEBUG,
  'REGZ BOX MODEL': DEBUG,
  'REGZ BOX SERVICE': DEBUG,
  'REVIEWS CONTROLLER': DEBUG,
  'REVIEWS MODEL': DEBUG,
  'REVIEWS SERVICE': DEBUG,
  ROOT_USER_MIDDLEWARE: DEBUG,
  SECURITY: DEBUG,
  'SIGN UP FOR OFFER CONTROLLER': DEBUG,
  SIGTERM: DEBUG,
  SPECIAL_OFFER_GATING: DEBUG,
  'ULTIMATE APPLY MODEL': DEBUG,
  'ULTIMATE APPLY SERVICE': DEBUG,
  ULTIMATE_APPLY_CONTROLLER: DEBUG,
  UNCAUGHT: DEBUG,
  'USER OFFER MIDDLEWARE': DEBUG,
  USER_CARDS: DEBUG,
  USER_CARDS_MODEL: DEBUG,
  USER_CARDS_SERVICE: DEBUG,
  USER_DATA_CONTROLLER: DEBUG,
  USER_DATA_MODEL: DEBUG,
  USER_SESSION_DATA_MIDDLEWARE: DEBUG,
  VERSION_CNTRL_VERIFIER: DEBUG,
  'VIEW ALL CARDS CONTROLLER': DEBUG,
  X_FRAME_OPTIONS: DEBUG
};

var getEvtcLevels = function getEvtcLevels() {
  return evtcLevels;
};

exports.getEvtcLevels = getEvtcLevels;

var setLevels = function setLevels() {
  var replacementLevels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var newLevels = _objectSpread({}, evtcLevels, {
    replacementLevels: replacementLevels
  });

  evtcLevels = newLevels;
  return evtcLevels;
};

exports.setLevels = setLevels;